__turbopack_context__.v({
  "emptyContainer": "video-selector-module__czwbpa__emptyContainer",
  "loadingContainer": "video-selector-module__czwbpa__loadingContainer",
  "videoSelector": "video-selector-module__czwbpa__videoSelector",
});
